module.exports = __webpack_public_path__ + "img/5.b3fd4c4c.jpg";